import React from 'react';

import { Divider, Splitter } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { useLocalDispatch, useLocalSelector } from '@app/services/hooks/useRedux';
import { resetFilters } from '@app/store/productsReducer';
import { useProductModal } from '@pages/Catalogs/providers';

import { useGetWarehouseProductsQuery, useResponsiveSplitDirection } from '../../../../../../hooks';

import { CatalogTable } from './components/CatalogTable';
import { WarehouseTable } from './components/WarehouseTable';

interface IProps {
  warehouse_uid: string;
}

export const ContentContainer: React.FC<IProps> = ({ warehouse_uid }) => {
  const catalogsT = useTranslation(NSKeys.catalogs);
  const direction = useResponsiveSplitDirection(980);
  const dispatch = useLocalDispatch();
  const filterSearchString = useLocalSelector((state) => state.products.filterSearchString);
  const filterTags = useLocalSelector((state) => state.products.filterTags);
  const filterCategories = useLocalSelector((state) => state.products.filterCategories);
  const filterBrands = useLocalSelector((state) => state.products.filterBrands);

  const { selectedRows } = useProductModal();

  const { data, isLoading } = useGetWarehouseProductsQuery({
    q: filterSearchString,
    warehouse_uid,
    only_positive_stock: true,
    category_id: filterCategories,
    tag_id: filterTags,
    brand_id: filterBrands,
  });

  React.useEffect(() => {
    return () => {
      dispatch(resetFilters());
    };
  }, []);

  return (
    <Splitter vertical={direction === 'vertical'}>
      <Splitter.Panel defaultSize="50%" min="30%" max="70%">
        <Divider size="large" titlePlacement="left" style={{ padding: '0 10px' }}>
          {catalogsT.t('form.productInWarehouseTitle')} ({data?.items?.length})
        </Divider>
        <WarehouseTable data={data?.items} isLoading={isLoading} />
      </Splitter.Panel>
      <Splitter.Panel>
        <Divider size="large" titlePlacement="left" style={{ padding: '0 10px' }}>
          {catalogsT.t('form.productInCatalogTitle')} ({selectedRows.length})
        </Divider>
        <CatalogTable />
      </Splitter.Panel>
    </Splitter>
  );
};
